import { network } from 'services/network';

export const reorderRankForStoredFilterBulkAssignTags = (params) => {
    return network.post('api/bo/reorderRankForStoredFilterBulkAssignTags', params).then((response) => response.data);
};
